import { memo } from 'react';
import { Link } from 'react-router-dom';

export const Footer = memo(function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      role="contentinfo"
      className="border-t bg-card/50 px-4 py-8"
    >
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-6 sm:gap-4 sm:flex-row sm:items-center sm:justify-between">
          
          {/* Left Section */}
          <div className="flex flex-col items-center sm:items-start gap-3">
            <nav
              aria-label="Footer Navigation"
              className="flex flex-wrap justify-center sm:justify-start gap-x-5 gap-y-2 text-sm"
            >
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/contact" className="footer-link">Contact Us</Link>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <Link to="/terms" className="footer-link">Terms & Conditions</Link>
            </nav>

            <p className="text-xs text-muted-foreground">
              Made & Managed by <span className="font-medium text-foreground">Ayush Patel</span>
            </p>
          </div>

          {/* Right Section */}
          <p className="text-sm text-muted-foreground text-center sm:text-right">
            © {currentYear} All-in-One Tools. All rights reserved.
          </p>

        </div>
      </div>
    </footer>
  );
});
